import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

let thePhone = null;

if(localStorage.getItem('cart')) {
    /*defaultCart = JSON.parse(localStorage.getItem("cart"));*/
}
if(localStorage.getItem('phone')){
    thePhone = localStorage.getItem('phone')
}
export default new Vuex.Store({
    state: {
        categories:[],
        cart:[],
        offerBody:null,
        selectedOfferId:null,
        selectedOfferPrice:null,
        fixedSelectedPrice:null,
        offerBodyLoading:false,
        showPopUp:false,
        quantity:1,
        askForPhone:false,
        phone:thePhone,
        setUserData:{},
        storedItem:{},
        getUserData:localStorage.getItem('userData'), 
    },
    mutations: {
        setItemToCart(state,playload){
            state.cart.push(playload)
        },
        removeItem(state, playload) {
            console.log(playload)
            state.cart = state.cart.filter(item=>{
                return item.offer_id != playload && item.id != playload
            })
            let userData = {};
            if(typeof this.state.getUserData == 'string') {
                userData = JSON.parse(this.state.getUserData)
            } else {
                userData = this.state.getUserData
            }   

            let formData = new FormData();

            formData.append('action', 'delete_from_cart');
            formData.append('cartPhoneNumber', userData.phone)
            formData.append('offerId',Number(playload))
            axios.post('', formData)
        },
        setOfferBody(state,playload) {
            state.offerBody = playload;
            state.quantity = 1;
            state.selectedOfferPrice = playload["initial_price"]
            state.fixedSelectedPrice = playload["initial_price"]
        },
        setShowPopUp(state) {
            state.showPopUp = true
        },
        setHidePopUp(state) {
            state.showPopUp = false;
        },
        async plusQuantity(state){
            state.quantity ++
            let formData = new FormData()
            formData.append('action', 'get_item_price_for_quantity')
            formData.append('offer_id',state.selectedOfferId);
            formData.append('quantity', state.quantity)
            let response = await axios.post('',formData)
            if(response.data.price) {
                state.selectedOfferPrice = response.data.price;
            } else {
                state.selectedOfferPrice = +state.fixedSelectedPrice * state.quantity
            }
        },
        async minusQuantity(state)  {
            if(state.quantity > 1) {
                state.quantity --;
                let formData = new FormData()
                formData.append('action', 'get_item_price_for_quantity')
                formData.append('offer_id',state.selectedOfferId);
                formData.append('quantity', state.quantity)
                let response = await axios.post('',formData)
                if(response.data.price) {
                    state.selectedOfferPrice = response.data.price;
                } else {
                    state.selectedOfferPrice = +state.fixedSelectedPrice * state.quantity
                }   
            }
        },
        hideAskPhone(state){
            state.askForPhone = false;
        },
        setPhone(state, playload) {
            state.setUserData = playload;
            state.getUserData = playload;
            localStorage.setItem('userData',JSON.stringify({"phone":playload.phone,"name":playload.name, "address":playload.address}))
            state.getUserData = state.setUserData;


        }
    },
    actions: {

        addPhone() {
            let formData = new FormData()
            formData.append('action', 'add_to_cart_by_phone_offerid_quantity_address')
            formData.append('phoneone', this.state.setUserData.phone)
            formData.append('quantity', this.state.quantity)
            formData.append('name', this.state.setUserData.name);
            formData.append('address', this.state.setUserData.address)
            formData.append('offer_id', Number(this.state.storedItem.id))
            axios.post(``,formData)
            .then(()=>{
                //get cart items 
                let formData = new FormData();
                let userData = {}
                if(typeof this.state.getUserData == 'string') {
                    userData = JSON.parse(this.state.getUserData)
                } else {
                    userData = this.state.getUserData
                }   
                if(userData) {
                    formData.append('action','get_cart_attributes')
                    formData.append('cartPhoneNumber', userData.phone);
                    axios.post('',formData)
                    .then(res=>{
                        this.state.cart = res.data.items;
                    })
                }
            })


            //animation
            let element = document.getElementById("shopcard");
            let element2 = document.getElementById("shopcard2");
            setTimeout(function(){
              element.classList.add("animated");
              element.classList.add("bounce");
              element2.classList.add("animated");
              element2.classList.add("bounce");
    
            }, 500)
        },
        show() {
            this.state.showPopUp = true
        },
        addToCart(context, item){
            
            let theItem = item;
            theItem.selling_price = item.first_offer_price;
            theItem.item_image_path = item.image_path;
            let userData = {}
            this.state.storedItem = theItem;
            console.log(typeof this.state.getUserData)
            if(typeof this.state.getUserData == 'string') {
                userData = JSON.parse(this.state.getUserData)
            } else {
                userData = this.state.getUserData
            }   
            
            if(this.state.getUserData) {
                let carts = this.state.cart;

                let formData = new FormData()
                formData.append('action', 'add_to_cart_by_phone_offerid_quantity_address')
                formData.append('phoneone', userData.phone)
                formData.append('quantity', this.state.quantity)
                formData.append('name', this.state.setUserData.name);
                formData.append('address', this.state.setUserData.address)
                formData.append('offer_id', Number(this.state.storedItem.id))


                axios.post(``,formData)
                .then(()=>{
                    //get cart items 
                    let formData = new FormData();
                    let userData = {}
                    if(typeof this.state.getUserData == 'string') {
                        userData = JSON.parse(this.state.getUserData)
                    } else {
                        userData = this.state.getUserData
                    }   
                    if(userData) {
                        formData.append('action','get_cart_attributes')
                        formData.append('cartPhoneNumber', userData.phone);
                        axios.post('',formData)
                        .then(res=>{
                            this.state.cart = res.data.items;
                        })
                    }
                })

                //animation
                let element = document.getElementById("shopcard");
                let element2 = document.getElementById("shopcard2");
                
                setTimeout(function(){
                  element.classList.add("animated");
                  element.classList.add("bounce");
                  element2.classList.add("animated");
                  element2.classList.add("bounce");
        
                }, 500)
            } else {
        
                this.state.askForPhone = true
            }

            //context.commit('setItemToCart', item)
        },
        removeFromCart(context, item){
            // let carts = this.state.cart
            // carts = carts.filter(cart=>{
            //     return cart.id != item
            // })
            // localStorage.setItem('cart', JSON.stringify(carts))
    
            context.commit("removeItem", item)
        },
        getOfferBody(context, id) {
            //store offer id
            this.state.selectedOfferId  = id

            //get offer
            let formData = new FormData();
            formData.append('action','get_offer_by_id')
            formData.append('offer_id', id)
            this.state.offerBodyLoading = true;
            axios.post('', formData)
            .then(res=>{
                let handleoffer = res.data
                //handle cover img
                handleoffer['offer_image_path'] = handleoffer['offer_image_path'].replace('images/', 'https://offers-jo.easysooq.net/images/')
                
                //handle offer body
                let regex = new RegExp('../img-uploads', "g");
                handleoffer['offer_body'] =handleoffer['offer_body'].replace(regex, 'https://offers-jo.easysooq.net/img-uploads')
                context.commit("setOfferBody", handleoffer);
                this.state.offerBodyLoading = false
            })
            .catch(()=>{
                this.state.offerBodyLoading = false;
            })
        },

        getCardItems() {
            let formData = new FormData();
            let userData = {}
            if(typeof this.state.getUserData == 'string') {
                userData = JSON.parse(this.state.getUserData)
            } else {
                userData = this.state.getUserData
            }
            if(userData) {
                formData.append('action','get_cart_attributes')
                formData.append('cartPhoneNumber', userData.phone);
                axios.post('',formData)
                .then(res=>{
                    if(res.data.items) {
                        this.state.cart = res.data.items;
                    }
                    
                })
            }

        },
        removeUserInfo() {
            localStorage.removeItem('userData');
            this.state.getUserData = {}
            location.reload(); 
        }
    }
})
